export class PaBookAppointmentModal{
    constructor(
        private doctorId: string,
        private caseId: string,
        private date: Date,
        private startTime,
        private endTime,
        private saHospId:string,
        private reason:string

        )
        {

    }
}
